"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "porcia": {
    "59ff01b0": [{
      "hkey": "4ff0f3ad",
      "slug": "centro-roraipiccolo-talponedo",
      "name": "Centro-Roraipiccolo-Talponedo",
      "primary": true,
      "skipSearch": false
    }],
    "roraipiccolo": [{
      "hkey": "4ff0f3ad",
      "slug": "centro-roraipiccolo-talponedo",
      "name": "Centro-Roraipiccolo-Talponedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cc4ecf41": [{
      "hkey": "4ff0f3ad",
      "slug": "centro-roraipiccolo-talponedo",
      "name": "Centro-Roraipiccolo-Talponedo",
      "primary": true,
      "skipSearch": false
    }],
    "talponedo": [{
      "hkey": "4ff0f3ad",
      "slug": "centro-roraipiccolo-talponedo",
      "name": "Centro-Roraipiccolo-Talponedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "be0c3d44": [{
      "hkey": "4ff0f3ad",
      "slug": "centro-roraipiccolo-talponedo",
      "name": "Centro-Roraipiccolo-Talponedo",
      "primary": true,
      "skipSearch": false
    }],
    "centro-roraipiccolo-sant-antonio-talponedo": [{
      "hkey": "4ff0f3ad",
      "slug": "centro-roraipiccolo-talponedo",
      "name": "Centro-Roraipiccolo-Talponedo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9a54366a": [{
      "hkey": "a9649bd0",
      "slug": "porcia",
      "name": "Porcia",
      "primary": true,
      "skipSearch": false
    }],
    "spinazzedo": [{
      "hkey": "a9649bd0",
      "slug": "porcia",
      "name": "Porcia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;